import { documentApi } from '@/api/documentApi'
import { RequestOptions } from '@/models/RequestOptions'

import { archiveApi } from '@/api/archiveApi'
import { fileApi } from '@/api/fileApi'
import { proofreadingApi } from '@/api/proofreadingApi'

export class homePageService {

    public static MaxDocumentsAllowed = 5

    async uploadDocument(file: any, configuration: any) {
        return fileApi.uploadDocument(file, configuration);
    }

    async loadDocuments(options: RequestOptions) {
        return documentApi.getUserDocuments(options);
    }

    async loadArchivedDocuments(options: RequestOptions) {
        return archiveApi.getUserArchivedDocuments(options);
    }

    async deleteDocument(documentId: number) {
        return documentApi.deleteDocument(documentId);
    }

    async deleteArchiveDocument(documentId: number) {
        return archiveApi.deleteArchiveDocument(documentId);
    }

    async archiveDocument(documentId: number) {
        return archiveApi.archiveDocument(documentId);
    }

    async exportForProofreading(documentId: number) {
        return proofreadingApi.exportForProofreading(documentId)
    }

    maxFileCountreached(filesCount: number) {
        return filesCount >= homePageService.MaxDocumentsAllowed;
    }

    async getDocumentsCount() {
        return documentApi.getDocumentsCount();
    }

}
